/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CurrentStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentStaffQuery = { viewer: { staff: { guid: string } } };


export const CurrentStaffDocument = gql`
    query CurrentStaff {
  viewer {
    staff {
      guid
    }
  }
}
    `;

/**
 * __useCurrentStaffQuery__
 *
 * To run a query within a Vue component, call `useCurrentStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentStaffQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCurrentStaffQuery();
 */
export function useCurrentStaffQuery(options: VueApolloComposable.UseQueryOptions<CurrentStaffQuery, CurrentStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentStaffQuery, CurrentStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentStaffQuery, CurrentStaffQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CurrentStaffQuery, CurrentStaffQueryVariables>(CurrentStaffDocument, {}, options);
}
export function useCurrentStaffLazyQuery(options: VueApolloComposable.UseQueryOptions<CurrentStaffQuery, CurrentStaffQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CurrentStaffQuery, CurrentStaffQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CurrentStaffQuery, CurrentStaffQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CurrentStaffQuery, CurrentStaffQueryVariables>(CurrentStaffDocument, {}, options);
}
export type CurrentStaffQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CurrentStaffQuery, CurrentStaffQueryVariables>;